export default __webpack_public_path__ + "locales/sk/Article.json?hash=a71c41a83b6af1564defa2f8e61d8749";